import React, { useState } from 'react';
import includes from 'lodash/includes';
import { useRouter } from 'next/router';
import { Box, useMediaQuery } from '@chakra-ui/react';

import { SideMenu } from './SideMenu';
import { MobileSideMenu } from './MobileSideMenu';
import { desktopMediaQueryWidth, sideNavWidth, sideNavWidthCollapsed } from './constants/styles';

interface NavigationProps {
  children: React.ReactNode;
}
interface SideMenuCallbackData {
  open: boolean;
}

export const Navigation = ({ children }: NavigationProps) => {
  const [sideMenuCallbackData, changeSideMenuCallbackData] = useState({ open: true });
  const router = useRouter();

  const [isDesktop] = useMediaQuery(desktopMediaQueryWidth, { ssr: false });

  const inCompass = includes(router.asPath, 'compass');

  // This callback will allow for the navigation component to listen for changes in
  // the child SideNav, so that it can change the padding styles accordingly
  const sideMenuCallback = (sideMenuData: SideMenuCallbackData) => changeSideMenuCallbackData(sideMenuData);

  const getSideNavSpacing = () => {
    if (sideMenuCallbackData.open) {
      return `${sideNavWidth}px`;
    }

    if (!sideMenuCallbackData.open) {
      return `${sideNavWidthCollapsed}px`;
    }
  };

  return inCompass ? (
    <>{children}</>
  ) : (
    <Box data-testid="navigation" backgroundColor="background-subtle">
      <SideMenu callback={sideMenuCallback} open={sideMenuCallbackData.open} isDesktop={isDesktop} />
      <MobileSideMenu />

      <Box paddingLeft={isDesktop ? getSideNavSpacing() : '0px'} transition={'padding-left 0.3s ease'}>
        {children}
      </Box>
    </Box>
  );
};
